import { APP_AUTHOR } from '@/generated/appMeta'

// Manually maintained metadata
export const APP_ISSUES_URL = ''
export const APP_CREDITS = 'Built with Vite/Vuetify3'
export const APP_COPYRIGHT = `Copyright © 2026 ${APP_AUTHOR}`
export const APP_LICENSE = 'Proprietary Software'
export {
  APP_AUTHOR,
  APP_NAME,
  APP_VERSION,
  APP_WEBSITE_URL,
} from '@/generated/appMeta'
